import type { components } from '@fluencelabs/vodopad-admin-api'

import client from '@/api/client'
import { createByIdsCache } from '@/hooks/createByIdsCache'

type AdminUserDto = components['schemas']['AdminUserDto']

const usersCache = createByIdsCache<AdminUserDto>({
  queryKeyPrefix: 'usersByIds',
  fetcher: async (ids) => {
    const res = await client.GET('/v2/admin/users', {
      params: { query: { ids: [...ids], page: 1, perPage: ids.length } },
    })
    return res.data?.items ?? []
  },
  getId: (user) => user.id,
})

export const useUsersByIds = usersCache.useByIds
export const useUsersCache = usersCache.useCache
export const UsersCacheProvider = usersCache.Provider
